import { render, staticRenderFns } from "./TmGrid.vue?vue&type=template&id=99bf0e9e"
import script from "./TmGrid.vue?vue&type=script&lang=ts"
export * from "./TmGrid.vue?vue&type=script&lang=ts"
import style0 from "./TmGrid.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModuleHeader: require('/app/components/base/ModuleHeader/ModuleHeader.vue').default})
